export enum RegionUrlOrigin {
  US = 'https://go.airship.com',
  EU = 'https://go.airship.eu',
}

const getCurrentFullPath = (): string =>
  window.location.pathname + window.location.search

const getCurrentOrigin = (): string => window.location.origin

export const getCurrentUrl = (): string =>
  `${getCurrentOrigin()}${getCurrentFullPath()}`

export const getCurrentUrlUS = (): string =>
  new URL(`${RegionUrlOrigin.US}${getCurrentFullPath()}`).toString()

export const getCurrentUrlEU = (): string =>
  new URL(`${RegionUrlOrigin.EU}${getCurrentFullPath()}`).toString()
